<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 시설정보 -->
    <write-grid-container title="시설정보" v-model="form.시설정보" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div v-if="dataType === 'selector' && form.시설정보[value]" class="print-input">{{ form.subInfo[value].fileName }}</div>
          <div v-else class="print-input">{{ form.시설정보[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <vs-select v-if="dataType === 'selector'" class="w-full" autocomplete v-model="form.시설정보[value]" >
            <vs-select-item v-for="item in ecoFlow.items" :text="item.label" :value="item.value"/>
          </vs-select>
          <ml-input v-else class="w-full" v-model="form.시설정보[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <EcoFlowSelector  />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import ecoFlow from "@/views/boards/single-page/978/ecoFlow";
import EcoFlowSelector from "@/views/boards/single-page/978/EcoFlowSelector.vue";

export default {
  components: {
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
    EcoFlowSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    ecoFlow() {
      return ecoFlow
    },
    selectEcoFlowId() {
      return this.$route.query.p;
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        시설정보: {},
        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["selector", "string", "string", "string", "string", "string"],
        labels: ["공정명", "공정번호", "관리번호", "시설명", "용량", "시설번호"],
        values: ["공정명", "공정번호", "관리번호", "시설명", "용량", "시설번호"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    if (this.selectEcoFlowId) {
      this.form.시설정보.공정명 = this.selectEcoFlowId
    }

  },
  methods: {
  },
};
</script>

<style scoped lang="scss"></style>
